import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Button, TableCell, TableRow } from "@material-ui/core";
import clsx from "clsx";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { getOriginLocationString, getDestinationLocationString } from "../../../../common/helpers";
import { NeedIcon, NeedListItem, AcuityNeedItem, PriorityBadge } from "../../TransferIcons";
import { useHistory } from "react-router";
import { useDrag } from "react-dnd";
import DraggingTransfer from "../../planner/DraggingTransfer";
import { getEmptyImage } from "react-dnd-html5-backend";
import { Targets } from "../../../../common/dndHelper";
import { IDropResult, TimelineCommandType } from "../../types/plannerTypes";
import { IVirtualTrip } from "../../../../common/plannerTypes";
import { getShortFullName } from "../../planner/plannerHelpers";
import { getLastVersionVisualState, getLastVersionGlobalState, mapFromIScheduleToSingleVirtualTrip } from "../../planner/virtualTripHelpers";
import { useDispatch } from "react-redux";
import { showTripDetailsModal } from "../../../../store/modules/plannerSliceModals";
import { MODAL_TYPE } from "../../planner/PlannerTripDetails";
import CompassIcon from "../../helpers/CompassIcon";
import moment from "moment";
import { convertTZ,convertTZConvertion} from "../plannerHelpers";

const timeToAgoString = (date: any,timezone : any): string => {
  const timenow = convertTZ(new Date(),timezone);
  const datetime = convertTZConvertion(new Date(date),null)
  const diffMin = Math.floor((timenow - datetime) / 60000);
  if (diffMin <= 0) {
    return "Just Now";
  } else {
    const diffHours = Math.floor(diffMin / 60);
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays > 0 ? diffDays + "d " : ""}${diffHours > 0 ? (diffHours % 20) + "h " : ""}${diffMin % 60 > 0 ? (diffMin % 60) + "m" : ""} ago`;
  }
};

const RequestedTransferItem = (props: any) => {
  const { transferRequest, updatedTransfers, getRequestedStatusString, showAdHocRequestModal, setDraggingItemName, setIsRequestedItemDragging,roles } = props;


  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
 
  const [{ isDragging }, drag, preview] = useDrag(() => ({
    type: "TransferRequest",
    item: {
      transferId: transferRequest.transferId,
      mobility: transferRequest.mobility,
      priority: transferRequest?.priority,
      pickupBeforeTime: transferRequest?.pickupBeforeTime,
      pickupAfterTime: transferRequest?.pickupAfterTime,
      dropoffBeforeTime: transferRequest?.dropoffBeforeTime,
      dropoffAfterTime: transferRequest?.dropoffAfterTime,
      transferAcuity: transferRequest?.classification,
      from: "RequestedTransferItem"
    },
    end: (item, monitor) => {  
      const dropResult = monitor.getDropResult() as IDropResult;
      dispatch(
        showTripDetailsModal({
          showTripDetails: false,
          tripDetails: null,
          tripDetailsModalType: MODAL_TYPE.TRIP_DETAILS,
          blockLabel: null,
        })
      );
      if (item && dropResult && dropResult.target === Targets.AD_HOC_REQUESTS) {
        const lastVersionOfGlobalState = getLastVersionGlobalState().map((r: IVirtualTrip) => r.transfers[0].scheduleObj);
        const lastVersionOfTransfer = lastVersionOfGlobalState.find((t) => t.transferId === transferRequest.transferId);
        showAdHocRequestModal({
          transferId: transferRequest.transferId,
          mobility: lastVersionOfTransfer?.mobility,
          priority: lastVersionOfTransfer?.priority,
          pickupBeforeTime: lastVersionOfTransfer?.pickupBeforeTime,
          pickupAfterTime: lastVersionOfTransfer?.pickupAfterTime,
          dropoffBeforeTime: lastVersionOfTransfer?.dropoffBeforeTime,
          dropoffAfterTime: lastVersionOfTransfer?.dropoffAfterTime,
        });
        return;
      }
      if (dropResult && dropResult.target === Targets.PLANNER_TIMELINE) {
        const lastVersionOfGlobalState = getLastVersionGlobalState().map((r: IVirtualTrip) => r.transfers[0].scheduleObj);
        const lastVersionOfTransfer = lastVersionOfGlobalState.find((t) => t.transferId === transferRequest.transferId);
        var updatedTransferRequest:any={...lastVersionOfTransfer};
        if (updatedTransferRequest) {
          updatedTransferRequest.isTripMinOverrided = false;
          updatedTransferRequest.overrideTripEstimateInMin = 0;
          updatedTransferRequest.eta = null;
          updatedTransferRequest.showETA = false;
      }
        if (dropResult?.plannerMinute?.trip) {
          // mostly insurance that it take last version of the trip
          const lastVersionOfTrip = getLastVersionVisualState().find((v) => v.virtualTripId === dropResult.plannerMinute?.trip?.virtualTripId);
          var updatedlastVersionOfTrip:any={...lastVersionOfTrip};
            if (lastVersionOfTrip && updatedlastVersionOfTrip) {
              updatedlastVersionOfTrip.isTripMinOverrided = false;
              updatedlastVersionOfTrip.overrideTripEstimateInMin = 0;
              updatedlastVersionOfTrip.eta = null;
              updatedlastVersionOfTrip.showETA = false;
          }
          dropResult.applyTimelineChanges(mapFromIScheduleToSingleVirtualTrip(updatedTransferRequest), {
            type: TimelineCommandType.addToTrip,
            tripUpdates: updatedlastVersionOfTrip,
          });
          return;
        } else {
          dropResult.applyTimelineChanges(mapFromIScheduleToSingleVirtualTrip(updatedTransferRequest), {
            type: TimelineCommandType.moveTrip,
            plannerMinute: dropResult.plannerMinute,
          });
          return;
        }
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  }));

  React.useEffect(() => {
    preview(getEmptyImage());
  }, []);

  React.useEffect(() => {
    setIsRequestedItemDragging(isDragging)
    setDraggingItemName(getShortFullName(transferRequest.firstName, transferRequest.lastName))
  }, [isDragging]);

  React.useEffect(() => {
    let _transferAcuityString = localStorage.getItem("transferAcuity");
    let _transferAcuityList = null;
    if (_transferAcuityString) {
      _transferAcuityList = JSON.parse(_transferAcuityString);
      let _resultMap = new Map(Object.entries(_transferAcuityList));
      _resultMap.set(transferRequest.transferId, transferRequest.classification);
      const result = Object.fromEntries(_resultMap);
      localStorage.setItem("transferAcuity",JSON.stringify(result));
    }
    else {
      let _resultMap = new Map<string, number>();
      _resultMap.set(transferRequest.transferId, transferRequest.classification);
      const result = Object.fromEntries(_resultMap);
      localStorage.setItem("transferAcuity",JSON.stringify(result));
    }
    
  }, [transferRequest]);

  return (
    <>
      <div
        className={clsx(classes.tableRow, {
          [classes.animatedUpdatedItem]: updatedTransfers.some(
            (e: any) => e.TransferId === transferRequest.transferId && new Date().getTime() - e.UpdatedDate < 60000
          ),
          [classes.isDragging]: isDragging,
        })}
        onClick={(e) => history.push(`/transferDetails/${transferRequest.bookingId}/${transferRequest.transferId}`)}
        ref={drag}
      >
        <div className={classes.multiLoadColumn}></div>
        <div className={classes.pickupTimeColumn}>{timeToAgoString(transferRequest.createdOn,transferRequest.timezone)}</div>
        <div className={classes.patientColumn}>
          {transferRequest.firstName[0]} {transferRequest.lastName}
        </div>
        <div className={classes.needsColumn}>
          {transferRequest.bookingSpecialNeeds.map((item: any) => (
            <NeedIcon
              key={transferRequest.bookingId + item.specialNeedId}
              iconName={item.specialNeedIconUrl.split("/")[item.specialNeedIconUrl.split("/").length - 1]}
            />
          ))}
          {transferRequest.mobility === 1 && <NeedListItem key="notambulant" text={"Not Ambulant"} iconUrl={"../../assets/svgs/nonambulant.svg"} />}
          {transferRequest.mobility !== 1 && <NeedListItem key="ambulant" text={"Ambulant"} iconUrl={"../../assets/svgs/ambulant.svg"} />}
          {transferRequest.classification && <AcuityNeedItem key="acuity" text={transferRequest.classification} />}
        </div>
        <div className={classes.fromColumn}>{getOriginLocationString(transferRequest, true)}</div>
        <div className={classes.toColumn}>
          <span style={{ float: "left" }}>
            <CompassIcon angle={transferRequest.bearingAngle || 0} theme={"dark"} />
          </span>
          {getDestinationLocationString(transferRequest, true)}
        </div>

        <div className={classes.priorityColumn}>
          <PriorityBadge priority={transferRequest.priority} />
        </div>
        <div className={classes.statusColumn}>{getRequestedStatusString(transferRequest)}</div>

        <div className={classes.actionButtonColumn}>
          <IconButton aria-label="expand row" size="small">
            <ArrowForwardIosIcon style={{ fontSize: 20 }} />
          </IconButton>
        </div>
      </div>

      {/* {isDragging && (
        <DraggingTransfer name={getShortFullName(transferRequest.firstName, transferRequest.lastName)} adjustForTransferRequest={true} />
      )} */}
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: "flex",
    alignItems: "center",
    color: "#FFFFFF",
    fontWeight: 500,
    backgroundColor: "rgb(2, 72, 157, 0.23)",
    height: 45,
    minHeight: 45,
    maxHeight: 45,
    fontSize: "18px",
    lineHeight: "22px",
    borderTop: "1px solid #00152E",
    cursor: "pointer",

    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },

    "&:not(:last-child)": {
      borderBottom: "1px solid #00152E",
    },
  },
  tableCell: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    height: 33,
  },
  animatedUpdatedItem: {
    animation: `$updatedTransferEffect 60000ms ease-out`,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08) !important",
    },
  },
  "@keyframes updatedTransferEffect": {
    "0%": { backgroundColor: "#F4B8273A" },
    "100%": { backgroundColor: "#002047" },
  },
  multiLoadColumn: {
    flex: "0 0 53px",
    display: "flex",
    justifyContent: "center",
    height: "100%",
  },
  patientColumn: {
    paddingLeft: 10,
    flex: "1 1 169px",
    display: "flex",

    "& span": {
      color: "#010B18",
      opacity: "0.39",
    },

    "@media (max-width: 1280px)": {
      display: "none",
    },
  },
  pickupTimeColumn: {
    paddingLeft: 15,
    flex: "0 0 171px",
  },
  needsColumn: {
    paddingLeft: 15,
    flex: "0 0 164px",
    display: "flex",
    alignItems: "center",

    "& img": {
      width: 18,
      height: 18,
    },
    "@media (max-width: 1280px)": {
      display: "none",
    },
  },
  fromColumn: {
    paddingLeft: 15,
    flex: "1 1 248px",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  toColumn: {
    paddingLeft: 15,
    flex: "1 1 248px",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  priorityColumn: {
    flex: "0 0 47px",
  },
  statusColumn: {
    flex: "1 1 245px",
  },
  actionButtonColumn: {
    paddingLeft: 15,
    paddingRight: 10,
    flex: "0 0 32px",
    display: "flex",
    justifyContent: "flex-end",
  },
  isDragging: {
    opacity: 0.2,
  },
}));

export default RequestedTransferItem;
